// Compact conversation picker. The native messaging service owns all record actions.
(function () {
  'use strict';
  function init() {
    var host = document.querySelector('.lxTop_M');
    if (!host || host.dataset.lpChatObserver || !window.lx || !lx.topMenu) { return; }
    host.dataset.lpChatObserver = 'true';
    var hr = /^hr/i.test(document.documentElement.lang);
    var labels = hr ? {
      title:'Razgovori', search:'Pretraži osobe i razgovore', close:'Zatvori',
      newChat:'Novi razgovor', all:'Svi razgovori', read:'Označi sve kao pročitano',
      unread:'Nepročitano', recent:'Nedavni razgovori', empty:'Još nema razgovora.',
      hint:'Započnite razgovor s novim kontaktom.', attachment:'Privitak',
      retry:'Pokušaj ponovno', error:'Razgovore nije moguće učitati.', write:'Napišite poruku',
      emoji:'Dodaj emotikon', minimize:'Smanji razgovor', maximize:'Proširi razgovor'
    } : {
      title:'Chats', search:'Search people and conversations', close:'Close',
      newChat:'New chat', all:'All chats', read:'Mark all as read',
      unread:'Unread', recent:'Recent conversations', empty:'No conversations yet.',
      hint:'Start a conversation with a contact.', attachment:'Attachment',
      retry:'Try again', error:'Could not load conversations.', write:'Write a message',
      emoji:'Add emoji', minimize:'Minimize chat', maximize:'Expand chat'
    };
    function el(tag, cls, text) {
      var node = document.createElement(tag); node.className = cls || '';
      if (text) { node.textContent = text; } return node;
    }
    function icon(name) { var node = el('span', 'far fawe-' + name); node.setAttribute('aria-hidden', 'true'); return node; }
    function button(text, name, cls) {
      var node = el('button', 't-Button lp-chat-action ' + (cls || ''));
      node.type = 'button'; node.appendChild(icon(name)); node.appendChild(el('span', '', text)); return node;
    }
    function dismiss() {
      lx.topMenu.removeClickListener();
      var trigger = host.querySelector('.t-Button--navBar'); if (trigger) { trigger.focus(); }
    }
    function plainMessage(value) {
      // A template is inert; attachment markup is never inserted into the live document.
      var template = document.createElement('template'); template.innerHTML = String(value || '');
      return (template.content.textContent || '').replace(/\s+/g, ' ').trim();
    }
    lx.topMenu.genMsgRow = function (row) {
      var unread = row.unread || lx.msg.newChats[row.id];
      var node = el('button', 'box lp-chat-row' + (unread ? ' hl' : ''));
      node.type = 'button'; node.dataset.conversationId = Number(row.id);
      var images = el('span', 'lp-chat-avatars');
      (row.recipients || []).slice(0, 2).forEach(function (recipient) {
        if (!recipient.img) { return; }
        var image = el('span', 'lp-chat-avatar');
        image.innerHTML = lx.profile.genPic(Object.assign({}, recipient.img, {size:'S'})); images.appendChild(image);
      });
      if (!images.children.length) { images.appendChild(icon('comments')); }
      node.appendChild(images);
      var content = el('span', 'lp-chat-row-content');
      var heading = el('span', 'lp-chat-row-heading');
      heading.appendChild(el('span', 'lp-chat-name', row.subject));
      if (unread) { heading.appendChild(el('span', 'lp-chat-unread', labels.unread)); }
      content.appendChild(heading);
      content.appendChild(el('span', 'lp-chat-people', (row.recipients || []).map(function (r) { return r.fname; }).join(', ')));
      var preview = plainMessage(row.msg) || labels.attachment;
      content.appendChild(el('span', 'lp-chat-preview', (row.senderName ? row.senderName + ': ' : '') + preview));
      content.appendChild(el('span', 'lp-chat-time', row.ts));
      node.appendChild(content); return node.outerHTML;
    };
    lx.topMenu.genMsg = function () {
      var data = lx.topMenu.msg;
      var search = el('div', 'topMenuSearch lp-chat-search');
      var label = el('label', '', labels.search); label.htmlFor = 'topMenuMsgsTerm'; search.appendChild(label);
      var field = el('input'); field.id = 'topMenuMsgsTerm'; field.type = 'search';
      field.autocomplete = 'off'; field.placeholder = labels.search; search.appendChild(field);
      var results = el('div', 'topMenuResults'); results.id = 'topMenuMsgsResults';
      results.setAttribute('aria-label', labels.recent);
      results.innerHTML = data.rows.map(lx.topMenu.genMsgRow).join('') || '<p class="lp-chat-empty">' + labels.empty + '</p>';
      if (data.rows.length) {
        var more = el('div', 'box loadMore', lx.topMenu.loading); more.id = 'loadMoreM'; results.appendChild(more);
      }
      return search.outerHTML + '<div class="lp-chat-list-label">' + labels.recent + '</div>' + results.outerHTML;
    };
    var timer, request, revision = 0;
    function search(value) {
      clearTimeout(timer); var current = ++revision;
      if (request && request.abort) { request.abort(); }
      lx.topMenu.observeMoreMsg.disconnect();
      timer = setTimeout(function () {
        var results = host.querySelector('#topMenuMsgsResults'); if (!results) { return; }
        results.setAttribute('aria-busy', 'true'); lx.topMenu.fetchInProgress = true;
        request = apex.server.process('getTopMenuJson', {x01:'M', x02:0, x03:value}, {
          dataType:'json',
          success:function (data) {
            if (current !== revision || !results.isConnected) { return; }
            lx.topMenu.msg.rows = data.rows;
            results.innerHTML = data.rows.map(lx.topMenu.genMsgRow).join('');
            if (!data.rows.length) { results.appendChild(el('p', 'lp-chat-empty', value ? data.loc.noResults : labels.empty)); }
            if (data.rows.length >= data.pageRows - 1) {
              var more = el('div', 'box loadMore', lx.topMenu.loading); more.id = 'loadMoreM'; results.appendChild(more);
              lx.topMenu.observeMoreMsg.observe(more);
            }
          },
          error:function (_, status) {
            if (current !== revision || status === 'abort' || !results.isConnected) { return; }
            results.replaceChildren(el('p', 'lp-chat-empty', labels.error));
            var retry = button(labels.retry, 'redo'); retry.dataset.chatRetry = 'true'; results.appendChild(retry);
          },
          complete:function () {
            if (current === revision) { lx.topMenu.fetchInProgress = false; results.removeAttribute('aria-busy'); request = null; }
          }
        });
      }, 250);
    }
    // Keep existing callers on this same search owner, including queued rapid edits.
    lx.topMenu.searchMsgs = function (input) { search(input.value); };
    host.addEventListener('input', function (event) { if (event.target.id === 'topMenuMsgsTerm') { search(event.target.value); } });
    host.addEventListener('click', function (event) {
      var row = event.target.closest('[data-conversation-id]');
      if (row) { lx.msg.chatOpen(Number(row.dataset.conversationId)); }
      if (event.target.closest('[data-chat-retry]')) { search(host.querySelector('#topMenuMsgsTerm').value); }
    });
    host.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lx.topMenu.opened === 'M') { event.preventDefault(); event.stopPropagation(); dismiss(); }
      else if (event.key === 'Enter' && event.target.id === 'topMenuMsgsTerm') {
        event.preventDefault();
        if (event.ctrlKey) { var first = host.querySelector('.lp-chat-row'); if (first) { first.click(); } }
      }
    });
    function decorate() {
      var menu = host.querySelector('.lxTop'); if (!menu || menu.dataset.lpChatReady) { return; }
      var header = menu.querySelector(':scope > .hdr'); if (!header) { return; }
      menu.dataset.lpChatReady = 'true'; menu.classList.add('lp-chat-menu');
      menu.setAttribute('role', 'region'); menu.setAttribute('aria-label', labels.title);
      var actions = Array.from(header.querySelectorAll('.t-Button'));
      var title = el('div', 'lp-chat-title-row'); title.appendChild(el('h2', '', labels.title));
      var close = button(labels.close, 'times', 'lp-chat-close'); close.setAttribute('aria-label', labels.close);
      close.addEventListener('click', dismiss); title.appendChild(close);
      header.replaceChildren(title);
      var toolbar = el('div', 'lp-chat-toolbar');
      // Move native action nodes, retaining their exact signed links and handlers.
      [2, 0, 1].forEach(function (index) {
        var action = actions[index]; if (!action) { return; }
        action.classList.remove('col', 'col-12', 'apex-col-auto', 't-Button--padTop');
        action.classList.add('lp-chat-action');
        action.replaceChildren(icon(['external-link', 'check-double', 'edit'][index]), el('span', '', [labels.all, labels.read, labels.newChat][index]));
        action.title = [labels.all, labels.read, labels.newChat][index];
        if (!action.matches('button, a')) {
          action.setAttribute('role', 'button'); action.tabIndex = 0;
          action.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); action.click(); }
          });
        }
        if (index === 1) { action.classList.add('lp-chat-read'); action.setAttribute('aria-label', labels.read); }
        toolbar.appendChild(action);
      });
      header.appendChild(toolbar);
      var appHeader = document.getElementById('t_Header');
      if (appHeader) {
        var geometry = function () { menu.style.setProperty('--lp-chat-top', Math.max(0, appHeader.getBoundingClientRect().bottom) + 'px'); };
        geometry(); var observer = new ResizeObserver(geometry); observer.observe(appHeader);
        var removal = new MutationObserver(function () { if (!menu.isConnected) { observer.disconnect(); removal.disconnect(); } });
        removal.observe(host, {childList:true});
      }
    }
    new MutationObserver(decorate).observe(host, {childList:true, subtree:true}); decorate();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
